<div class="layout-footer">
    <img src="assets/randg_logo_{{layoutService.config.colorScheme === 'light' ? 'white' : 'black'}}.png" alt="Logo" height="20" class="mr-2"/>
    <span class="font-medium mr-2">Scrivendium</span>
    by
    <span class="font-medium ml-2">Rune and Gear</span>
</div>
